//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapActions, mapState } from 'vuex';
import UserReferralProgram from '~/views/UserReferral/UserReferralProgram/UserReferralProgram.vue';
import UserReferralReferralsOld from '~/views/UserReferral/UserReferralReferrals/UserReferralReferralsOld.vue';
import UserReferralReferralsNew from '~/views/UserReferral/UserReferralReferrals/UserReferralReferrals.vue';
import UserReferralIncomes from '~/views/UserReferral/UserReferralIncomes/UserReferralIncomes.vue';
import UserReferralCharges from './UserReferralCharges/UserReferralCharges.vue';
import constant from '~/const';

export default {
  components: {
    UserReferralProgram,
    UserReferralReferralsOld,
    UserReferralReferralsNew,
    UserReferralIncomes,
    UserReferralCharges,
  },

  data() {
    return {
      constant,
    };
  },

  computed: {
    ...mapState('user', ['user']),
  },

  async mounted() {
    this.setGeneralLoader(true);
    if (this.$utils.getAppType() === 'p2pay') {
      await Promise.allSettled([
        this.loadTraderLeadReferralsAction({ leadId: this.user.id }),
      ]);
    } else {
      await Promise.allSettled([
        this.loadUserReferralIncomes(),
        this.loadUserReferralReferrals(),
      ]);
    }
    this.setGeneralLoader(false);
  },

  methods: {
    ...mapActions('common', ['setGeneralLoader']),
    ...mapActions('userReferralIncomes', {
      loadUserReferralIncomes: 'loadData',
    }),
    ...mapActions('userReferralReferrals', {
      loadUserReferralReferrals: 'loadData',
    }),
    ...mapActions('referrals', {
      loadTraderLeadReferralsAction: 'loadTraderLeadReferrals',
    }),
  },
};
